<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <lg-form-const-select label="Situação:" sm="2" md="2" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load()" />

                    <lg-form-input v-model="form.descricao" label="Descrição:" description=" " cols="6" sm="6" md="6" />

                    <b-col cols="1" class="mt-2">
                        <b-button id="localizarExercicioFiscal" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarExercicioFiscal" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col>

                    <b-col cols="1" class="text-right mt-2">
                        <b-button v-if="temPrivilegioCriacao()" id="novoExercicioFiscal" class="my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="novoExercicioFiscal" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>

                <b-table responsive class="mt-2" small :busy="busy" :items="records" :fields="tableFields" :hover="true"
                    show-empty @row-dblclicked="clickRow">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(finalizarExercicioFiscal)="row">

                        <div :id="'finalizarExercicioFiscal-' + row.index" v-if="row.item.statusId != 141">
                            <b-button :disabled="!temPrivilegioEdicao()" :id="'finalizarExercicioFiscal-' + row.index"
                                variant="primary" size="sm" class="mr-2 ml-2"
                                @click="finalizarExercicioFiscal(row.item)">
                                <b-tooltip :target="'finalizarExercicioFiscal-' + row.index"
                                    title="Finalizar Exercício Fiscal"></b-tooltip>
                                <b-icon icon="check-circle" />
                            </b-button>
                        </div>
                        <div v-else>
                            <b-button :disabled="!temPrivilegioEdicao()" :id="'iniciarExercicioFiscal-' + row.index"
                                variant="primary" size="sm" class="mr-2 ml-2"
                                @click="finalizarExercicioFiscal(row.item)">
                                <b-tooltip :target="'iniciarExercicioFiscal-' + row.index"
                                    title="Colocar Exercício Fiscal em Vigência"></b-tooltip>
                                <b-icon icon="check-circle" />
                            </b-button>
                        </div>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchExercicioFiscal'">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchExercicioFiscal'"
                                title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2"
                            size="sm" pill variant="primary" @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(dataInicial)="row">
                        {{ formatDate(row.item.dataInicial) }}
                    </template>

                    <template v-slot:cell(dataFinal)="row">
                        {{ formatDate(row.item.dataFinal) }}
                    </template>

                    <template v-slot:cell(tipoExercicioFiscalDescricao)="row">
                        {{ row.item.tipoExercicioFiscalDescricao }}
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            Página {{ page }} de {{ totalPage }} - {{ total }} registros
                        </b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="load()" :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ExercicioFiscalForm
          v-if="show"
          @close="cancelar"
          :prefix="prefix + title + ' > '"
          :id="id"
        />
    </b-card>
</template>

<script>
import ExercicioFiscalService from "@/core/api/ExercicioFiscalService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio";
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum";
import ExercicioFiscalForm from "./ExercicioFiscalForm.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import StatusEnum from "@/core/utils/StatusEnum";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        ExercicioFiscalForm,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    data() {
        return {
            title: "Exercício Fiscal",
            id: null,
            show: false,
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            busy: false,
            records: [],
            total: 0,
            totalPage: 0,
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/exercicio-fiscal`);
        this.$serviceExercicioFiscal = new ExercicioFiscalService();
        this.load();

    },
    computed: {
        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },
                { key: "tipoExercicioFiscalDescricao", label: "Tipo" },
                { key: "dataInicial", label: "Data Inicial" },
                { key: "dataFinal", label: "Data Final" },
                { key: "statusDescricao", label: "Status" },
                { key: "finalizarExercicioFiscal", label: " ", tdClass: "w-1" },
                { key: "action", label: " ", tdClass: "w-1" },
                { key: "situacao", label: " ", tdClass: "w-1" },
            ];
        },
    },
    watch: {
        page() {
            this.load();
        },
    },

    methods: {
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);
        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);
        },
        async editar(item) {
            this.id = item.id;
            this.show = true;
        },
        async load() {
            this.busy = true;
            const filtro = {};
            if (this.form.descricao) {
                filtro.descricao = this.form.descricao;
            }
            if (this.form.situacao != null) {
                filtro.situacao = this.form.situacao;
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.show = true;
        },
        async clickRow(item) {
            this.$emit("close", item);
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Exercício Fiscal?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },


        async finalizarExercicioFiscal(item) {
            const confirmMsg =
                item.statusId == StatusEnum.EXERCICIO_CADASTRADO.value?"Colocar Exercício Fiscal em vigência":
                "Finalizar Exercício Fiscal?";
            const response = await this.$confirm(confirmMsg);

            if (response) {
                await this.confirmarFinalizacao(item);
            }
        },
        async confirmarFinalizacao(item) {
            try {
                await this.$serviceExercicioFiscal.alterarStatus(item.id);

                this.$notify({
                    type: "success",
                    message: `Registro finalizado com sucesso!`,
                });

            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }
        },
        formatDate(date) {
            return date ? new Date(date).toLocaleDateString() : "";
        },
    },
};
</script>
